import React from 'react'
import { DisplayFinancialEntityPosition } from 'components/DueDiligence/Questions'
import { addKeyToObjectsArray } from 'utils/addUniqueKeyToObjects'
import AutomaticQuestions from 'components/ProspectDashboard/AutomaticQuestions'
import { Expansible } from 'components/Expansible'

import styles from './styles'

function BuildRepresentationActivityReviewInfo(props) {
  const { reviewData } = props

  const classes = styles()

  return (
    <div className={classes.root}>
      <h2>Dados auxiliares para a análise</h2>
      <Expansible title="Respostas do formulário Due Diligence">
        {addKeyToObjectsArray(reviewData?.related_form_answers)?.map(
          (answer) => {
            return <DisplayFinancialEntityPosition questionData={answer?.answer_object} axa={true} />
          })    }
      </Expansible>
      {reviewData?.extra_questions && (
        <Expansible title="Respostas às questões automáticas relacionadas à pergunta">
          <AutomaticQuestions questions={reviewData?.extra_questions} />
        </Expansible>
      )}
    </div>
  )
}


export default BuildRepresentationActivityReviewInfo
